// src/composables/useShare.js - ✅ GESTURE FIXED
import { ref } from 'vue'

export function useShare() {
  const canNativeShare = ref(!!navigator.share)

  const shareContent = (title, text, url) => {  // SYNC - preserves gesture
    const shareUrl = url.startsWith('http') ? url : `${window.location.origin}/${url.replace(/^\//, '')}`
    const shareData = { 
      title: title || 'Share', 
      text: text || '', 
      url: shareUrl 
    }

    if (canNativeShare.value && navigator.canShare?.(shareData)) {
      navigator.share(shareData)
        .then(() => console.log('✅ Native share'))
        .catch(err => {
          if (err.name !== 'AbortError') {  // User cancelled = normal
            navigator.clipboard.writeText(shareUrl)
              .then(() => console.log('📋 Fallback copied'))
          }
        })
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => console.log('📋 Copied'))
    }
  }

  return { shareContent, canNativeShare }
}
